import { fieldInputTypes } from '../../../constants/fieldInputTypes';
import { inputTypes } from '../../form/FormInput/util';

export const requiredCustomPolicyStack = [
  {
    name: 'policyName',
    label: 'Policy Name',
    placeholder: 'Custom Policy Name',
    required: true,
    validationRules: {
      required: { value: true, message: 'Custom Policy Name is a required field' },
      minLength: { value: 3, message: 'Custom Policy must have at least three characters' },
      maxLength: { value: 64, message: 'Custom Policy Name must have fewer than 64 characters' }
    }
  },
  {
    name: 'description',
    label: 'Description',
    placeholder: 'Type your thoughts...',
    type: 'textArea',
    required: false,
    validationRules: {
      maxLength: {
        value: 280,
        message: 'Custom Policy Description must have fewer than 280 characters'
      }
    }
  }
];

export const customPolicyPropertiesStack = {
  [fieldInputTypes.Checkboxes]: {
    isChecked: true,
    isDisabled: true,
    width: '100%',
    description: '',
    dataType: 'boolean',
    type: inputTypes.checkBox
  },
  [fieldInputTypes.Monetary]: {
    name: 'label',
    label: 'Monetary Property Label',
    placeholder: 'Policy Field Type Label',
    width: '100%',
    description: '',
    validationRules: {
      required: { value: true, message: 'Policy Limit Label is a required field' },
      maxLength: { value: 64, message: 'Policy Limit Label must have fewer than 64 characters' }
    }
  },
  [fieldInputTypes.AlphaNumeric]: {
    name: 'label',
    label: 'Alphanumeric Property Label',
    placeholder: 'Policy Field Type Label',
    width: '100%',
    description: '',
    validationRules: {
      required: { value: true, message: 'Policy Limit Label is a required field' },
      maxLength: { value: 64, message: 'Policy Limit Label must have fewer than 64 characters' }
    }
  }
};

export const editCustomPolicyPropertiesStack = {
  [fieldInputTypes.Checkboxes]: {
    isChecked: true,
    isDisabled: false,
    width: '100%',
    description: '',
    dataType: 'boolean',
    isReadOnly: true,
    type: inputTypes.checkBox
  },
  [fieldInputTypes.Monetary]: {
    name: 'label',
    label: 'Label',
    placeholder: 'Policy Field Type Label',
    width: '100%',
    description: '',
    validationRules: {
      required: { value: true, message: 'Policy Limit Label is a required field' },
      maxLength: { value: 64, message: 'Policy Limit Label must have fewer than 64 characters' }
    }
  },
  [fieldInputTypes.AlphaNumeric]: {
    name: 'label',
    label: 'Label',
    placeholder: 'Policy Field Type Label',
    width: '100%',
    description: '',
    validationRules: {
      required: { value: true, message: 'Policy Limit Label is a required field' },
      maxLength: { value: 64, message: 'Policy Limit Label must have fewer than 64 characters' }
    }
  }
};
